import { useState, useEffect } from "react";
import { TutorialCompletionData } from "../v32/components/RecipeDeckOnboardingOverlay";

export const useTutorialState = (key: string = "recipeDeckTutorial") => {
  const [isFirstVisit, setIsFirstVisit] = useState(false);
  const [tutorialData, setTutorialData] =
    useState<TutorialCompletionData | null>(null);

  useEffect(() => {
    const storedTutorialData = localStorage.getItem(key);

    if (!storedTutorialData) {
      setIsFirstVisit(true);
    } else {
      const parsedData = JSON.parse(storedTutorialData);
      setTutorialData(parsedData);

      // Logic to determine if tutorial should be shown again
      const TUTORIAL_RESET_INTERVAL = 30 * 24 * 60 * 60 * 1000; // 30 days
      const timeSinceLastTutorial = Date.now() - parsedData.timestamp;

      setIsFirstVisit(timeSinceLastTutorial > TUTORIAL_RESET_INTERVAL);
    }
  }, [key]);

  const completeTutorial = (data: TutorialCompletionData) => {
    localStorage.setItem(key, JSON.stringify(data));
    setTutorialData(data);
    setIsFirstVisit(false);
  };

  const resetTutorial = () => {
    localStorage.removeItem(key);
    setIsFirstVisit(true);
    setTutorialData(null);
  };

  return {
    isFirstVisit,
    tutorialData,
    completeTutorial,
    resetTutorial,
  };
};
